import { CSAT_RATINGS, CSAT_DISPLAY_TYPES } from 'shared/constants/messages';

export const buildFilterList = (items, type) =>
  items.map(item => ({
    id: item.id,
    name: type === 'ratings' ? item.emoji : item.name,
    type,
  }));

export const buildRatingsList = (t, displayType) => {
  const allRatings = CSAT_RATINGS.map(rating => ({
    id: rating.value,
    name: `${t(rating.translationKey)}`,
    type: 'ratings',
  }));

  const noResponse = {
    id: 'no_response',
    name: t('CSAT_REPORTS.FILTERS.RATINGS.NO_RESPONSE'),
    type: 'ratings',
  };

  if (displayType === CSAT_DISPLAY_TYPES.LIKE_DISLIKE) {
    return [
      ...allRatings
        .filter(r => r.id === 1 || r.id === 5)
        .map(r => ({
          ...r,
          name:
            r.id === 5
              ? `👍 ${t('CSAT_REPORTS.FILTERS.RATINGS.LIKE')}`
              : `👎 ${t('CSAT_REPORTS.FILTERS.RATINGS.DISLIKE')}`,
        })),
      noResponse,
    ];
  }

  return [...allRatings, noResponse];
};

export const buildLabelsList = items =>
  items.map(item => ({
    id: item.title,
    name: item.title,
    color: item.color,
    type: 'labels',
  }));

export const RESOLUTION_METHOD_OPTIONS = t => [
  {
    id: 'bot',
    name: t('CSAT_REPORTS.FILTERS.RESOLVED_BY.BOT'),
    type: 'resolution_methods',
  },
  {
    id: 'operator',
    name: t('CSAT_REPORTS.FILTERS.RESOLVED_BY.OPERATOR'),
    type: 'resolution_methods',
  },
];

export const HAS_COMMENT_OPTIONS = t => [
  {
    id: 'yes',
    name: t('CSAT_REPORTS.FILTERS.HAS_COMMENT.YES'),
    type: 'has_comments',
  },
  {
    id: 'no',
    name: t('CSAT_REPORTS.FILTERS.HAS_COMMENT.NO'),
    type: 'has_comments',
  },
];

export const getActiveFilter = (filters, type, key) => {
  if (type === 'labels') {
    return filters.find(item => item.title === key || item.id === key);
  }
  return filters.find(item => item.id.toString() === key.toString());
};

export const getFilterType = (input, direction) => {
  const filterMap = {
    keyToType: {
      user_ids: 'agents',
      inbox_id: 'inboxes',
      team_id: 'teams',
      rating: 'ratings',
      label_title: 'labels',
      exclude_label_title: 'exclude_labels',
      resolution_method: 'resolution_methods',
      has_comment: 'has_comments',
    },
    typeToKey: {
      agents: 'user_ids',
      inboxes: 'inbox_id',
      teams: 'team_id',
      ratings: 'rating',
      labels: 'label_title',
      exclude_labels: 'exclude_label_title',
      resolution_methods: 'resolution_method',
      has_comments: 'has_comment',
    },
  };
  return filterMap[direction][input];
};
